import { useEffect, useRef, useState } from 'react';
import { processSteps } from '../data/process';

export function ModernTimeline() {
  const [activeStep, setActiveStep] = useState(0);
  const stepRefs = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const idx = Number((entry.target as HTMLElement).dataset.step);
            setActiveStep(idx);
          }
        });
      },
      { threshold: 0.55, rootMargin: '-20% 0px -20% 0px' },
    );

    stepRefs.current.forEach((el) => {
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="modern-timeline">
      <div className="modern-timeline-track" aria-hidden="true">
        <div
          className="modern-timeline-progress"
          style={{ height: `${(activeStep / (processSteps.length - 1)) * 100}%` }}
        />
      </div>
      {processSteps.map((step, i) => (
        <div
          key={step.id}
          data-step={i}
          ref={(el) => {
            stepRefs.current[i] = el;
          }}
          className={`modern-timeline-step${i === activeStep ? ' is-active' : ''}`}
        >
          <div className="modern-timeline-node">
            <span className="modern-timeline-number">{step.number}</span>
          </div>
          <div className="modern-timeline-card card">
            <div className="modern-timeline-card-header">
              <span className="modern-timeline-label">Step {step.number}</span>
              <h3>{step.title}</h3>
            </div>
            <p className="modern-timeline-summary">{step.summary}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
